import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'join'
})
export class JoinPipe implements PipeTransform {

  transform(value: Array<string|number>, separator = '_'): string {
    return value.filter(i => i != null).join(separator);
  }

}
